import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { analyticsReducer } from './redux/reducers';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { createTracker } from 'redux-segment';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';

const tracker = createTracker();

const store = createStore(
  analyticsReducer,
  applyMiddleware(
    thunk,
    logger,
    tracker
  )
);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
